import { db } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  addDoc,
  getDoc,
} from "firebase/firestore";
import { FB_COLLECTION_PATH } from "./postActionTypes";

export async function chatFunction(
  profileReceived: any,
  associateReceived: any,
  chatCat: string,
): Promise<string> {
  try {
    // Check if there is already a chats document
    const existingChatId = await chatsDocCheck(profileReceived, associateReceived);
    
    if (existingChatId === "") {
      // Did not find the chat / chats documents - need to create them
      
      // Step 1: Create a chat document and wait for the ID
      const chatId = await createChatDoc(chatCat);
      // console.log("Created new chat doc with ID:", chatId);
      
      // Step 2: Setup the chats documents with the new chat ID
      await setupChatsDocs(profileReceived, associateReceived, chatId);
      // console.log("Setup chats docs completed");
      
      // Step 3: Return the new chat ID
      return chatId;
    } else {
      // Found existing chat - return the existing ID
      // console.log("Found existing chat:", existingChatId);
      return existingChatId;
    }
  } catch (error) {
    console.error("Error in chatFunction:", error);
    throw error; // Re-throw to let caller handle
  }
}

async function chatsDocCheck(profileReceived: any, associateReceived: any): Promise<string> {
  try {
    const docRef = doc(db, FB_COLLECTION_PATH.Chats, profileReceived.UserId);
    const docSnap = await getDoc(docRef);
    
    if (!docSnap.exists()) {
      return "";
    }

    // User has a chats document - check for existing DM
    const chatSnap = docSnap.data();
    
    for (const key in chatSnap) {
      if (chatSnap[key].DMuid === associateReceived.WerkerUid) {
        // Found existing chat
        return key; // Return the chat ID (key), not chatDocId
      }
    }
    
    // No existing chat found
    return "";
  } catch (error) {
    console.error("Error checking chats document:", error);
    return "";
  }
}

async function createChatDoc(chatCat: string): Promise<string> {
  try {
    const chatRef = collection(db, "chat");
    const chatDocRef = await addDoc(chatRef, {
      chatCategory: chatCat,
      messages: [],
      createdAt: Date.now(),
      updatedAt: Date.now()
    });
    
    return chatDocRef.id;
  } catch (error) {
    console.error("Error creating chat document:", error);
    throw error;
  }
}

async function setupChatsDocs(
  profileReceived: any, 
  associateReceived: any, 
  chatId: string
): Promise<void> {
  try {
    const newChatSender = doc(db, FB_COLLECTION_PATH.Chats, profileReceived.UserId);
    const newChatReceiver = doc(db, FB_COLLECTION_PATH.Chats, associateReceived.WerkerUid);
    
    // Setup sender's chat document
    await setDoc(newChatSender, {
      [chatId]: {
        isRead: true,
        messageDate: Date.now(),
        messagePreview: "Chat created",
        messageTitle: `${associateReceived.WerkerFirstName} ${associateReceived.WerkerLastName}`,
        sendersPic: associateReceived.WerkerProfilePicURL,
        DMuid: associateReceived.WerkerUid,
      }
    }, { merge: true });
    
    // Setup receiver's chat document
    await setDoc(newChatReceiver, {
      [chatId]: {
        isRead: true,
        messageDate: Date.now(),
        messagePreview: "Chat created", 
        messageTitle: `${profileReceived.FirstName} ${profileReceived.LastName}`,
        sendersPic: profileReceived.ProfilePicURL,
        DMuid: profileReceived.UserId,
      }
    }, { merge: true });
    
    // console.log("Chat documents setup completed for both users");
  } catch (error) {
    console.error("Error setting up chats documents:", error);
    throw error;
  }
}